import React from 'react';

export const caffeineDefaults = {
  caffeine_status: 'unknown',
  caffeine_mg_per_100ml: '',
  caffeine_source: '',
};

export function caffeineLabel(drink) {
  if (!['no', 'yes'].includes(drink.caffeine_status)) return 'Noch nicht erfasst';
  const amount = drink.caffeine_mg_per_100ml;
  const numeric = Number(String(amount ?? '').replace(',', '.'));
  const label = drink.caffeine_status === 'no'
    ? 'Nein (0 mg/100 ml)'
    : amount === null || amount === undefined || amount === '' || !Number.isFinite(numeric) || numeric <= 0
      ? 'Ja, Menge unbekannt'
      : `${numeric.toLocaleString('de-DE', { maximumFractionDigits: 3 })} mg/100 ml`;
  return `${label} · ${drink.caffeine_verification === 'verified' ? 'geprüft' : 'ungeprüft'}`;
}

export default function CaffeineFields({ form, setForm }) {
  const changeStatus = (event) => {
    const status = event.target.value;
    setForm((previous) => ({
      ...previous,
      caffeine_status: status,
      caffeine_mg_per_100ml: status === 'no' ? '0' : '',
    }));
  };
  const change = (event) => {
    const { name, value } = event.target;
    setForm((previous) => ({ ...previous, [name]: value }));
  };
  const field = { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 };
  const input = { width: '100%', boxSizing: 'border-box', minWidth: 0 };
  return (
    <fieldset style={{ display: 'grid', gap: 10, margin: 0, padding: 12, minWidth: 0, border: '1px solid #ccc', borderRadius: 6 }}>
      <legend>Koffein (optional)</legend>
      <label style={field}>Koffeinhaltig
        <select name="caffeine_status" value={form.caffeine_status} onChange={changeStatus} style={input}>
          <option value="unknown">Unbekannt / noch nicht erfasst</option>
          <option value="no">Nein</option>
          <option value="yes">Ja</option>
        </select>
      </label>
      {form.caffeine_status === 'yes' && (
        <label style={field}>Koffeingehalt (mg/100 ml)
          <input name="caffeine_mg_per_100ml" value={form.caffeine_mg_per_100ml} onChange={change} inputMode="decimal" pattern="[0-9]{1,4}([.,][0-9]{1,3})?" placeholder="z. B. 32" style={input} />
        </label>
      )}
      <small>Wert des trinkfertigen Getränks vom Etikett oder Hersteller übernehmen. Menge nicht bekannt? Leer lassen.</small>
      {form.caffeine_status !== 'unknown' && (
        <label style={field}>Quelle der Koffeinangabe (optional)
          <input name="caffeine_source" value={form.caffeine_source} onChange={change} maxLength={500} placeholder="Hersteller-URL oder Etikett mit Datum" style={input} />
        </label>
      )}
      <small>Neue Angaben werden als ungeprüft gespeichert.</small>
    </fieldset>
  );
}
